import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import './EngagementStats.css';

function formatNumber(n) {
  if (n >= 1000) {
    const k = Math.round(n / 100) / 10; // one decimal
    return `${k.toLocaleString('ru-RU')} тыс.`;
  }
  return n.toLocaleString('ru-RU');
}

function AnimatedNumber({ value }) {
  const motionVal = useMotionValue(0);
  const spring = useSpring(motionVal, { stiffness: 120, damping: 26 });
  const [display, setDisplay] = useState(formatNumber(0));

  useEffect(() => {
    const unsubscribe = spring.on('change', v => {
      setDisplay(formatNumber(Math.round(v)));
    });
    return () => unsubscribe && unsubscribe();
  }, [spring]);

  useEffect(() => {
    motionVal.set(value);
  }, [value, motionVal]);

  return <motion.span className="eng-num">{display}</motion.span>;
}

export default function EngagementStats({ className = '' }) {
  // Example values, you can wire these to real data
  const [views] = useState(3200);
  const [reposts] = useState(26);
  const [likes] = useState(316);
  const [bookmarks] = useState(32);

  return (
    <div className={`engagement-stats ${className}`}> 
      <div className="eng-item eng-main">
        {/* bars icon for views */}
        <svg className="eng-icon" viewBox="0 0 24 24" width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="10" width="3.5" height="8" rx="0.6" />
          <rect x="8.5" y="6" width="3.5" height="12" rx="0.6" />
          <rect x="14" y="3" width="3.5" height="15" rx="0.6" />
        </svg>
        <AnimatedNumber value={views} />
      </div>
      <div className="eng-item eng-small eng-reposts">
        {/* repost / repeat arrows (feather-style) */}
        <svg className="eng-icon" viewBox="0 0 24 24" width="18" height="18" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="17 1 21 1 21 5" />
          <path d="M3 11V9a4 4 0 0 1 4-4h14" />
          <polyline points="7 23 3 23 3 19" />
          <path d="M21 13v2a4 4 0 0 1-4 4H3" />
        </svg>
        <AnimatedNumber value={reposts} />
      </div>
      <div className="eng-item eng-small eng-likes">
        {/* heart icon for likes */}
        <svg className="eng-icon" viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20.8 6.6a5.5 5.5 0 0 0-7.8 0L12 7.6l-1-1a5.5 5.5 0 0 0-7.8 7.8L12 22.2l8.8-8.8a5.5 5.5 0 0 0 0-7.8z" />
        </svg>
        <AnimatedNumber value={likes} />
      </div>
      <div className="eng-item eng-small eng-bookmarks">
        {/* bookmark icon */}
        <svg className="eng-icon" viewBox="0 0 24 24" width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
        </svg>
        <AnimatedNumber value={bookmarks} />
      </div>
    </div>
  );
}
